import axios from "axios";
import config from "../config";
import * as ikasGql from "./ikas.graphql";

const IKAS_API_URL = config.IKAS_API_URL;
const HEADERS = {
  "Content-Type": "application/json",
  "X-API-KEY": config["X-API-KEY"],
  "x-sfrid": config["ROUTING_ID"],
  "x-sfid": "87c70d2d-9829-4bab-943f-25561689a049",
};

const api = async ({ query, variables = {} }) => {
  const token =
    sessionStorage.getItem("token") || localStorage.getItem("token");
  try {
    const { data } = await axios.post(
      IKAS_API_URL,
      { query, variables },
      { headers: { ...HEADERS, authorization: `Bearer ${token}` } }
    );
    if (data.errors)
      throw new Error(data.errors[0]?.message || "Ikas API error");
    return data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch Ikas data");
  }
};

// PRODUCTS
export const searchProducts = async (input) =>
  (await api({ query: ikasGql.SearchProducts, variables: { input } }))
    .searchProducts;

export const getProductFilterData = async (input) => {
  return (
    await api({ query: ikasGql.getProductFilterData, variables: { ...input } })
  ).getProductFilterData;
};

// CUSTOMER
export const getMyCustomer = async () => {
  const request = await api({ query: ikasGql.GetMyCustomer });
  return {
    key: "customer",
    value: request.getMyCustomer,
  };
};
export const customerLogin = async (email, password, rememberMe) => {
  const request = await api({
    query: ikasGql.CustomerLogin,
    variables: { email, password },
  });

  if (rememberMe) {
    localStorage.setItem("token", request.customerLogin.token);
    localStorage.setItem("tokenExpiry", request.customerLogin.tokenExpiry);
  } else {
    sessionStorage.setItem("token", request.customerLogin.token);
    sessionStorage.setItem("tokenExpiry", request.customerLogin.tokenExpiry);
  }
  return {
    key: "customer",
    value: request.customerLogin.customer,
  };
};
export const registerCustomer = async (
  email,
  password,
  firstName,
  lastName,
  phone,
  rememberMe
) => {
  const request = await api({
    query: ikasGql.RegisterCustomer,
    variables: { email, password, firstName, lastName, phone },
  });
  if (rememberMe) {
    localStorage.setItem("token", request.registerCustomer.token);
    localStorage.setItem("expiresAt", request.registerCustomer.expiresAt);
  } else {
    sessionStorage.setItem("token", request.registerCustomer.token);
    sessionStorage.setItem("expiresAt", request.registerCustomer.expiresAt);
  }
  return {
    key: "customer",
    value: request.registerCustomer.customer,
  };
};
export const saveMyCustomer = async (input) => {
  const request = await api({
    query: ikasGql.SaveMyCustomer,
    variables: { input },
  });

  return {
    key: "customer",
    value: request.saveMyCustomer,
  };
};
export const customerRefreshToken = async (token) => {
  const request = await api({
    query: ikasGql.CustomerRefreshToken,
    variables: { token },
  });
  return request.customerRefreshToken;
};
export const customerRecoverPassword = async (password, passwordAgain, token) =>
  (
    await api({
      query: ikasGql.CustomerRecoverPassword,
      variables: { password, passwordAgain, token },
    })
  ).customerRecoverPassword;
export const customerForgotPassword = async (email) => {
  const request = await api({
    query: ikasGql.CustomerForgotPassword,
    variables: { email },
  });
  return request.customerForgotPassword;
};
export const listCity = async (stateId) => {
  const request = await api({
    query: ikasGql.ListCity,
    variables: {
      stateId: {
        eq: stateId,
      },
    },
  });

  return request.listCity;
};
export const listDistrict = async (cityId) => {
  const request = await api({
    query: ikasGql.ListDistrict,
    variables: {
      cityId: {
        eq: cityId,
      },
    },
  });

  return request.listDistrict;
};
export const getCustomerOrders = async () => {
  const request = await api({
    query: ikasGql.GetCustomerOrders,
  });
  return {
    key: "orders",
    value: request.getCustomerOrders,
  };
};

// CART
export const getCart = async () => {
  const getCartId = localStorage.getItem("cartId");
  const customerId =
    localStorage.getItem("customerId") ?? sessionStorage.getItem("customerId");

  const request = await api({
    query: ikasGql.GetCart,
    variables: { getCartId, customerId },
  });
  console.log(request);
  return {
    key: "cart",
    value: request.getCart,
  };
};
export const addItemToCart = async (input) => {
  const request = await api({
    query: ikasGql.AddItemToCart,
    variables: { input },
  });
  localStorage.setItem("cartId", request.addItemToCart.id);
  return {
    key: "cart",
    value: request.addItemToCart,
  };
};
export const saveCart = async (input) => {
  const request = await api({
    query: ikasGql.SaveCart,
    variables: { input },
  });
  return {
    key: "cart",
    value: request.saveCart,
  };
};

export const checkout = (data) => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  const tokenExpiry =
    localStorage.getItem("tokenExpiry") ||
    sessionStorage.getItem("tokenExpiry");

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: "checkout",
        payload: JSON.stringify({ ...data, ...config, token, tokenExpiry }),
      })
    );
  }
};

export default {
  searchProducts,
  getMyCustomer,
  customerLogin,
  registerCustomer,
  saveMyCustomer,
  customerRefreshToken,
  customerRecoverPassword,
  getCart,
  addItemToCart,
  customerForgotPassword,
  listCity,
  listDistrict,
  getCustomerOrders,
  saveCart,
  checkout,
  getProductFilterData,
};
